import axios from 'axios'

import Settings from "../../settings.json";
const url = Settings.isNative ? Settings.frontlineArServer : "";

export class DayadaRequester {

    static async toggleIrrelevant(questionIndex, patientId) {
        const result = await axios.post(`${url}/dayada-manager/expert-toggle-irrelevant`, {questionIndex, patientId});
        return result.data;
    }

    static async answer(questionIndex, expertAnswers, patientId) {
        const result = await axios.post(`${url}/dayada-manager/expert-answer`, {
            questionIndex,
            expertAnswers,
            patientId
        });
        return result.data;
    }

    static async createPatient(procedureJson) {
        const result = await axios.post(`${url}/dayada-manager/create-patient`, procedureJson);
        return result.data;
    }

    static async getPatient(username) {
        const result = await axios.get(`${url}/dayada-manager/get-patient/${username}`);
        return result.data;
    }

    static async updatePatientDetails(patient) {
        const result = await axios.put(`${url}/dayada-manager/update-patient`, patient);
        return result.data;
    }

    static async resetPatientPassword(username) {
        const result = await axios.post(`${url}/dayada-manager/reset-patient-password`, {username});
        return result.data;
    }

    static async updateInnerComment(questionIndex, expertInnerComment, patientId) {
        const result = await axios.post(`${url}/dayada-manager/update-expert-inner-comment`, {
            questionIndex,
            expertInnerComment,
            patientId
        });
        return result.data;
    }


    static async setCommentFiles(newFileObjects, questionIndex, patientId) {
        const result = await axios.post(`${url}/dayada-manager/set-comment-files`, {
            newFileObjects,
            patientId,
            questionIndex
        });
        return result.data;
    }

    static async setRecommendationFiles(newFileObjects, category, patientId) {
        const result = await axios.post(`${url}/dayada-manager/set-recommendation-files`, {
            newFileObjects,
            category,
            patientId,
        });
        return result.data;
    }

    static async removeRecommendationFile(fileIndex, category, patientId) {
        const result = await axios.post(`${url}/dayada-manager/remove-recommendation-file`, {
            fileIndex,
            category,
            patientId
        });
        return result.data;
    }

    static async removeCommentFile(fileIndex, questionIndex, patientId) {
        const result = await axios.post(`${url}/dayada-manager/remove-comment-file`, {
            fileIndex, questionIndex, patientId
        });
        return result.data;
    }

    static async updateRecommendationText(text, category, patientId) {
        const result = await axios.post(`${url}/dayada-manager/update-recommendation-text`, {
            text,
            category,
            patientId,
        });
        return result.data;
    }

    static async deletePatient(patientId) {
        const result = await axios.delete(`${url}/dayada-manager/delete-patient/${patientId}`);
        return result.data;
    }
}
